<template>
    <div>
        <div class="card">
            <div class="card-header">
                联系人信息
            </div>
            <div class="card-body" style="min-height: 300px">
                <div v-if="personPagingData.itemCount === 0">
                    <div class="alert alert-warning">没有联系人信息，请创建</div>
                    <button class="btn btn-primary" @click="btnCreatePersonData_Click">创建联系人</button>
                </div>
                <div v-if="personPagingData.itemCount !== 0">
                    <table class="table table-bordered table-striped">
                        <thead>
                        <tr>
                            <th class="text-center align-middle" style="width: 5%">序号</th>
                            <th class="text-center align-middle" style="width: 10%">姓名</th>
                            <th class="text-center align-middle" style="width: 5%">性别</th>
                            <th class="text-center align-middle" style="width: 12%">职务</th>
                            <th class="text-center align-middle" style="width: 10%">职称</th>
                            <th class="text-center align-middle" style="width: 20%">部门</th>
                            <th class="text-center align-middle" style="width: 20%">人员类型</th>
                            <th class="text-center align-middle" style="width: 18%">详情</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(person, index) in personPagingData.data" :key="person.personId">
                            <td class="text-center align-middle">{{index+1}}</td>
                            <td class="text-center align-middle">{{person.personName}}</td>
                            <td class="text-center align-middle">{{person.genderName}}</td>
                            <td class="text-left align-middle">{{person.post}}</td>
                            <td class="text-left align-middle">{{person.title}}</td>
                            <td class="text-left align-middle">{{person.departmentName}}</td>
                            <td class="text-left align-middle">{{person.personTypeName}}</td>
                            <td class="text-center align-middle">
                                <button class="btn btn-info btn-sm mr-2" @click="btnShowPersonDetailInfo_Click(person.personId)">详情</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-6 text-left">
                        <nav aria-label="..." v-if="personPagingData.itemCount !== 0">
                            <b-pagination class="mb-0"
                                          v-model="filterCondition.page"
                                          :total-rows="personPagingData.itemCount"
                                          :per-page="filterCondition.rowCountPerPage"
                                          @input="page_Change"
                            />
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="isEditPersonInfoDialogOpen" @hidden="getPersonData()"
                 title="编辑联系人信息"
                 :hide-footer="true" size="xl"
                 :no-close-on-backdrop="true">
            <organ-person-basic-info-edit class="mb-3" :person-id="currentPersonId" :show-detail-info="showDetailInfo"></organ-person-basic-info-edit>
            <organ-person-contact-info-edit class="mb-3" :person-id="currentPersonId"></organ-person-contact-info-edit>
            <organ-person-work-info-edit class="mb-3" :person-id="currentPersonId"></organ-person-work-info-edit>
            <organ-person-description-info-edit :person-id="currentPersonId" :person-type="personType" v-if="showDetailInfo"></organ-person-description-info-edit>
        </b-modal>

        <b-modal v-model="isViewPersonInfoDialogOpen"
                 title="联系人信息详情"
                 :hide-footer="true" size="xl"
                 :no-close-on-backdrop="true">
            <organ-person-basic-info-view class="mb-3" :person-id="currentPersonId" :show-detail-info="showDetailInfo"></organ-person-basic-info-view>
            <organ-person-contact-info-view class="mb-3" :person-id="currentPersonId"></organ-person-contact-info-view>
            <organ-person-work-info-view class="mb-3" :person-id="currentPersonId"></organ-person-work-info-view>
            <organ-person-description-info-view :person-id="currentPersonId" :person-type="personType" v-if="showDetailInfo"></organ-person-description-info-view>
        </b-modal>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
import OrganPersonBasicInfoEdit from "@/views/organ/OrganPersonBasicInfoEdit";
import OrganPersonContactInfoEdit from "@/views/organ/OrganPersonContactInfoEdit";
import OrganPersonWorkInfoEdit from "@/views/organ/OrganPersonWorkInfoEdit";
import OrganPersonDescriptionInfoEdit from "@/views/organ/OrganPersonDescriptionInfoEdit";
import OrganPersonBasicInfoView from "@/views/organ/OrganPersonBasicInfoView";
import OrganPersonContactInfoView from "@/views/organ/OrganPersonContactInfoView";
import OrganPersonWorkInfoView from "@/views/organ/OrganPersonWorkInfoView";
import OrganPersonDescriptionInfoView from "@/views/organ/OrganPersonDescriptionInfoView"
export default {
    name: "OrganContactPersonEdit",
    components: {OrganPersonBasicInfoEdit, OrganPersonContactInfoEdit, OrganPersonWorkInfoEdit, OrganPersonDescriptionInfoEdit, OrganPersonBasicInfoView, OrganPersonContactInfoView, OrganPersonWorkInfoView, OrganPersonDescriptionInfoView},
    props: {
        ownerId: {type: String, required: true},
        personType: {type: Number, required: true},
        showDetailInfo: {type: Boolean, required: false, default: true},
    },
    data: function () {
        return {
            currentPersonId: null,
            personPagingData: {itemCount: 0},
            isViewPersonInfoDialogOpen: false,
            isEditPersonInfoDialogOpen: false,
            filterCondition: {
                ownerId: this.ownerId,
                personName: '',
                personType: this.personType,
                page: 1,
                rowCountPerPage: 20
            },
        };
    },
    mounted() {
        this.getPersonData();
    },
    methods: {
        getPersonData() {
            userApi.person.basic.getOrganDataWithPaging(this.filterCondition).then(res => {
                this.personPagingData = res.data
            });
        },
        btnShowPersonDetailInfo_Click(personId) {
            this.currentPersonId = personId
            this.isViewPersonInfoDialogOpen = true
        },

        btnCreatePersonData_Click() {
            userApi.person.createOrganContact({
                ownerId: this.ownerId,
                personType: this.personType
            }).then(res => {
                this.isEditPersonInfoDialogOpen = true
                this.currentPersonId = res.data.personId;
            })
        },
        page_Change() {
            this.getPersonData()
        }
    }
}
</script>

<style scoped>

</style>